import type { ScenarioLever, ScenarioLeverCategory, ScenarioLeverConfidence } from '../types';
import { formatEuroOptional } from '../utils/formatters';
import styles from './ScenarioLeversList.module.css';

const CATEGORY_LABELS: Record<ScenarioLeverCategory, string> = {
  investment: 'Portfolio',
  savings: 'Savings',
  debt: 'Debt',
  real_estate: 'Real estate',
  income: 'Income',
  other: 'Other',
};

const CONFIDENCE_LABELS: Record<ScenarioLeverConfidence, string> = {
  high: 'High confidence',
  medium: 'Medium confidence',
  low: 'Low confidence',
};

const CONFIDENCE_PILL_CLASS: Record<ScenarioLeverConfidence, string> = {
  high: styles.confidencePillHigh,
  medium: styles.confidencePillMedium,
  low: styles.confidencePillLow,
};

type ScenarioLeversListProps = {
  levers: ScenarioLever[];
};

export function ScenarioLeversList({ levers }: ScenarioLeversListProps) {
  if (levers.length === 0) {
    return <p className="muted">No levers suggested for this scenario.</p>;
  }

  return (
    <ul className={styles.list}>
      {levers.map((lever) => (
        <li key={lever.id} className={styles.card}>
          <div className={styles.cardHeader}>
            <div className={styles.cardTitles}>
              <span className={styles.category}>{CATEGORY_LABELS[lever.category]}</span>
              <h3 className={styles.title}>{lever.title}</h3>
            </div>
            <span
              className={`${styles.confidencePill} ${CONFIDENCE_PILL_CLASS[lever.confidence]}`}
            >
              {CONFIDENCE_LABELS[lever.confidence]}
            </span>
          </div>
          <p className={styles.description}>{lever.description}</p>
          {lever.impactEuros != null && Number.isFinite(lever.impactEuros) ? (
            <p className={styles.impact}>
              Estimated impact: <strong>{formatEuroOptional(lever.impactEuros)}</strong>
            </p>
          ) : null}
        </li>
      ))}
    </ul>
  );
}
